<template>
  <div class="full-body-content align-items-center">
    <b-row class="v-full justify-content-center">
      <b-col md="6" align-self="center">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-muted">The page you are looking for was not found.</p>
        </div>
          
        <b-img :src="$config.getAssetsURL('img/brand/AgriOpenMouth.png')" width="60" fluid alt="" />
        <b-button block variant="success" class="btn-home" :to="{ name:'Home' }">Let's Go Home !</b-button>

      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  mounted ()
  {
  },
}
</script>

<style lang="scss" scoped>
  .btn-home
  {
    font-size: 120%;
    padding: 10px 10px;
  }
</style>